import React, {useState} from 'react';
import {Modal} from "react-materialize";
import styled from "styled-components";

export const StyledUnreconciledModal = styled(Modal)`
  width: 82vw;
  
  .header {
    color: white;
    background: linear-gradient(135deg,#0f82c5,#07bb9c);
    padding: 1.5rem 2rem;
    
    .top-half, .bottom-half {
      display: flex;
      justify-content: space-between;
    }
    
    .top-half {
      p { 
        font-size: 2.5rem; 
      };
      
      margin-bottom: 0.5rem;
    }
    
    .bottom-half {
      p {
        font-size: 2rem;
      }
      
      .date {
        font-size: 2rem;
        color: #E1E1E1;
        display: flex;
        align-items: center;
        
        .pill {
          background-color: white;
          border-radius: 14px;
          color: #348AC0;
          padding: 0px 3px 0px 3px;
          font-size: 1.6rem;
          width: 6.5rem;
          height: 2rem;
          text-align: center;
          margin-right: 1.5rem;
        }
      }
    }
  }

  .modal-content {
    padding: 0;
    margin-top: 0;
    
    thead {
      border: 1px solid #DEDFE1;
    }
    
    .selected-transactions {
      margin-left: 3rem;
      margin-right: 3rem;
      margin-top: 3rem;
      
      .selected-total {
        display: flex;
        justify-content: space-between;
        margin-top: 2rem;
      }
    }
    
    .table-container {
      margin: 3rem;
      
      .check-box-td {
        position: relative;
        margin-right: 2.5rem;
        margin-left: 1rem;
        .children {
          position: absolute;
          top: 17px;
          left: 5px;
        }
      }
    }
  }
`